export const blockIconsHomeAutoMode = (
	<span className='material-symbols-outlined'>auto_mode</span>
);
